import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat-image-thumb" }

import { onMounted, onUnmounted, ref } from 'vue'
import instance from '@/api/instance'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageImage',
  props: {
    title: {},
    src: {}
  },
  emits: ['load'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const imageUrl = ref<string | null>(null)

onMounted(async () => {
  try {
    const response = await instance.get(props.src, {
      responseType: 'blob' // Чтобы получить изображение в виде Blob
    })

    const imageBlob = response.data
    imageUrl.value = URL.createObjectURL(imageBlob)
  } catch (error) {
    console.error('Ошибка при загрузке изображения', error)
  }
})

onUnmounted(() => {
  if (imageUrl.value) {
    URL.revokeObjectURL(imageUrl.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_skeleton, {
      loading: imageUrl.value === null,
      animated: ""
    }, {
      template: _withCtx(() => [
        _createVNode(_component_el_skeleton_item, {
          variant: "image",
          style: {"width":"100px","height":"100px"}
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          src: imageUrl.value,
          "preview-src-list": [imageUrl.value],
          "initial-index": 0,
          "max-scale": 3,
          "min-scale": 0.5,
          "hide-on-click-modal": "",
          onLoad: _cache[0] || (_cache[0] = ($event: any) => (emit('load')))
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})